var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/congrat_end.49a5269d.png","uri@3x": __webpack_public_path__ + "static/media/congrat_end.cd5e5f72.png","uri@2x": __webpack_public_path__ + "static/media/congrat_end.7e1324ad.png",
    width: 221,
    height: 220
});